import { useConfig } from '@/hook/useConfig';

const { CLS_PRE } = useConfig();

export { CLS_PRE };
